import React, {useState, useEffect } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { onAxiosApiCall, useLocalStorage, getLanguage } from "../../../../../utils";
import { API_URL } from "../../../../../constants";

export function AsideMenuList({ layoutProps }) {
  const location = useLocation();
  const [localStorageData] = useLocalStorage(
    "clientpanel"
  );
  const [paymentPortalLoding, setPaymentPortalLoding] = useState(false);
  const [menuList, setMenuList] = useState("");
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu &&
          "menu-item-active"} menu-item-open menu-item-not-hightlighted`
      : "";
  };
  const language = getLanguage(navigator.language, localStorageData);

  useEffect(() => {
    onAxiosApiCall(API_URL + language + "/get-client-panel-menu-list", "GET", "")
    .then((response) => {
      if (response.status === 200) {
        setMenuList(response.data);

        if(response?.data?.myreferral_screen !== undefined) {
          var globalReferAndEarnBtn = document.getElementById('globalReferAndEarnBtn');          
          if(globalReferAndEarnBtn) {
            var text_to_change = globalReferAndEarnBtn.childNodes[1];
            text_to_change.innerHTML = " " + response.data.myreferral_screen;
          }
        } 
      }
    })
    .catch((error) => {
      console.log("error", error);
    });
  },[]);

  const handlePaymentClick = () => {
    const currentRoute = window.location.href    
    var apiBody = {return_url : currentRoute};
    setPaymentPortalLoding(true);
    onAxiosApiCall(API_URL + "generate-customer-portal", "POST", apiBody)
      .then((response) => {
        if(response.status === 200 && response.data !== undefined && response.data.customerPortalUrl !== undefined) {
          window.location.href = response.data.customerPortalUrl;
        } else {
          Swal.fire("Error", response.error, "error");
        }
        setPaymentPortalLoding(false);
      })
      .catch((error) => {
        setPaymentPortalLoding(false);
        console.log("error", error);
      });
  }

  var paymentDisbleStyle = paymentPortalLoding ?  {pointerEvents: 'none', opacity: '0.7'} : {};
  return (
    <>
      <ul className={`menu-nav ${layoutProps.ulClasses}`} style={{ padding: 0, margin: '10px 0' }}>
        <li
          className={`menu-item ${getMenuItemActive("/my-videos", false)}`}          
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/my-videos">
            <span className="svg-icon menu-icon">
              <i className="fas fa-video"></i>
            </span>
            <span className="menu-text">{menuList.myvideo_screen}</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/my-scripts", false)}`}          
          
        >
          <NavLink className="menu-link" to="my-scripts">
            <span className="svg-icon menu-icon">
              <i className="far fa-file-alt"></i>
            </span>
            <span className="menu-text">{menuList.myscripts_screen}</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/my-deal", false)}`}          
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/my-deal">
            <span className="svg-icon menu-icon">
              <i className="fas fa-gift"></i>
            </span>
            <span className="menu-text">{menuList.mydeals_screen}</span>
          </NavLink>
        </li>
        
        {/* <li
          className={`menu-item ${getMenuItemActive("/my-goal", false)}`}          
          
        >
          <NavLink className="menu-link" to="/my-goal">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">My Goals</span>
          </NavLink>
        </li> */}
        {/* <li
          className={`menu-item ${getMenuItemActive("/my-rewards", false)}`}          
          
        >
          <NavLink className="menu-link" to="/my-rewards">
            <span className="svg-icon menu-icon">
              <i className="fas fa-gift"></i>
            </span>
            <span className="menu-text">My Incentive</span>
          </NavLink>
        </li> */}
        <li
          className={`menu-item ${getMenuItemActive("/my-advertising", false)}`}          
         
        >
          <NavLink className="menu-link" to="/my-advertising">
            <span className="svg-icon menu-icon">
              <i className="fas fa-image"></i>
            </span>
            <span className="menu-text">{menuList.myadvertising_screen}</span>
          </NavLink>
        </li> 
        <li
          className={`menu-item ${getMenuItemActive("/users", false)}`}          
          
        >
          <NavLink className="menu-link" to="/users">
            <span className="svg-icon menu-icon">
              <i className="fas fa-user-friends"></i>
            </span>
            <span className="menu-text">{menuList.myusers_screen}</span>
          </NavLink>
        </li>
        <li
          className={`menu-item ${getMenuItemActive("/my-statistics", false)}`}          
         
        >
          <NavLink className="menu-link" to="/my-statistics">
            <span className="svg-icon menu-icon">
              <i className="far fa-chart-bar"></i>
            </span>
            <span className="menu-text">{menuList.mystatistics_screen}</span>
          </NavLink>
        </li>  
        {/* <li
          className={`menu-item ${getMenuItemActive("/plans", false)}`}          
          
        >
          <NavLink className="menu-link" to="/plans">
            <span className="svg-icon menu-icon">
              <i className="fas fa-cog"></i>
            </span>
            <span className="menu-text">{menuList.plan_screen}</span>
          </NavLink>
        </li> */} 
        <li
          className={`menu-item ${getMenuItemActive("/plans-and-payment", false)}`}          
          
        >
          <NavLink className="menu-link" to="/plans-and-payment">
            <span className="svg-icon menu-icon">
              <i className="fas fa-money-bill-alt"></i>
            </span>
            <span className="menu-text">{menuList.my_payments_screen}</span>
          </NavLink>
        </li>

        {/* <li
          className={`menu-item disabled`}          
          style={{ margin: "5px 0", ...paymentDisbleStyle}}
          onClick={() => handlePaymentClick()}
        >
          <div className="menu-link">
            <span className="svg-icon menu-icon">
              <i className="fas fa-money-bill-alt"></i>
            </span>
            <span className="menu-text">{menuList.my_payments_screen} {
              paymentPortalLoding && 
                <CircularProgress style={{marginLeft: 5, color: '#fff'}} size={16} thickness={6}/>
              }
            </span>
          </div>
        </li> */}
        <li
          className={`menu-item ${getMenuItemActive("/my-settings", false)}`}          
          
        >
          <NavLink className="menu-link" to="/my-settings">
            <span className="svg-icon menu-icon">
              <i className="fas fa-cog"></i>
            </span>
            <span className="menu-text">{menuList.mysetting_screen}</span>
          </NavLink>
        </li> 
        <li
          className={`menu-item ${getMenuItemActive("/my-referral", false)}`}          
          
        >
          <NavLink className="menu-link" to="/my-referral">
            <span className="svg-icon menu-icon">
              <i className="fas fa-gift"></i>
            </span>
            <span className="menu-text">{menuList.myreferral_screen}</span>
          </NavLink>
        </li> 
        {/* <li
          className={`menu-item ${getMenuItemActive(
            "/sharing-settings",
            false
          )}`}         
         
        >
          <NavLink className="menu-link" to="/sharing-settings">
            <span className="svg-icon menu-icon">
              <i className="fas fa-share-alt"></i>
            </span>
            <span className="menu-text">Sharing Settings</span>
          </NavLink>
        </li>
       */}
      {/*   <li
          className={`menu-item ${getMenuItemActive("/clients", false)}`}
          
         
        >
          <NavLink className="menu-link" to="/clients">
            <span className="svg-icon menu-icon">
              <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")} />
            </span>
            <span className="menu-text">Control</span>
          </NavLink>
        </li>*/}

        <li className={`menu-item`} >
          <NavLink className="menu-link" to="/logout">
            <span className="svg-icon menu-icon">
              <i className="fas fa-sign-out-alt"></i>
            </span>
            <span className="menu-text">{menuList.logout_btn_text} </span>
          </NavLink>
        </li>
      </ul>

      <ul className={`menu-nav ${layoutProps.ulClasses}`} style={{ margin: '0', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <li
          className={`menu-item`}          
          style={{ padding: "0px 15px"}}
        >
          <img
            src={toAbsoluteUrl("/media/logos/white-logo.png")}
            className="max-w-150px max-h-150px"
            alt=""
          />
        </li>
        <li
          className={`menu-item pb-10 pb-sm-3`}          
          style={{ padding: "0px", }}
        >
          <a href="mailto:support@youshow.org" style={{ fontWeight: 600, fontSize: '1.2rem', textTransform: 'none',  color: '#fff' }}>support@youshow.org</a>
        </li>
      </ul>
    </>
  );
}
